import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel request-date-panel p-bottom-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "panel-heading has-background-light has-text-weight-semibold is-size-4" }, " Dates ", -1)
const _hoisted_3 = {
  key: 0,
  class: "panel-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestDueDate = _resolveComponent("RequestDueDate")!
  const _component_RequestReceivedDate = _resolveComponent("RequestReceivedDate")!
  const _component_RequestFulfillmentDate = _resolveComponent("RequestFulfillmentDate")!
  const _component_RequestExpirationDate = _resolveComponent("RequestExpirationDate")!
  const _component_NrLoadingAnimation = _resolveComponent("NrLoadingAnimation")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    (!_ctx.filteredRequestLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.canSeeRequestDueDate)
            ? (_openBlock(), _createBlock(_component_RequestDueDate, {
                key: 0,
                prettyId: _ctx.prettyId,
                date: _ctx.dueDate
              }, null, 8, ["prettyId", "date"]))
            : _createCommentVNode("", true),
          (_ctx.received)
            ? (_openBlock(), _createBlock(_component_RequestReceivedDate, {
                key: 1,
                prettyId: _ctx.prettyId,
                date: _ctx.received,
                requestSubmitType: _ctx.requestSubmitType
              }, null, 8, ["prettyId", "date", "requestSubmitType"]))
            : _createCommentVNode("", true),
          (_ctx.canSeeFulfillmentDate)
            ? (_openBlock(), _createBlock(_component_RequestFulfillmentDate, {
                key: 2,
                prettyId: _ctx.prettyId,
                date: _ctx.fulfillment
              }, null, 8, ["prettyId", "date"]))
            : _createCommentVNode("", true),
          (_ctx.canSeeRequestExpirationDate)
            ? (_openBlock(), _createBlock(_component_RequestExpirationDate, {
                key: 3,
                prettyId: _ctx.prettyId,
                exempt: _ctx.exemptFromRetention,
                expiration: _ctx.expiration
              }, null, 8, ["prettyId", "exempt", "expiration"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
          key: 1,
          count: 3
        }))
  ]))
}